import { render } from "./primarySidebar.vue?vue&type=template&id=54c1da96&scoped=true"
import script from "./primarySidebar.vue?vue&type=script&lang=js"
export * from "./primarySidebar.vue?vue&type=script&lang=js"

import "./primarySidebar.vue?vue&type=style&index=0&id=54c1da96&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c1da96"]])

export default __exports__